module.exports = __webpack_public_path__ + "static/confiable-05187e87abe8b8ec30256c1e29537210.svg";